import { Form } from "@/shared/form/Form";
import { FormFieldType } from "@/shared/form/FormDefinition";

/**
 * `content.bookInfo` — Angaben zum Bauwerksbuch.
 *
 * The inspection history is composed once at report creation from the prior
 * inspections of the building (or the configured fallback standard text) and is
 * editable Markdown from then on: the renderer prints the stored value and never
 * recomposes it, so an edit here is what ends up in the PDF.
 *
 * No label carries a chapter number: the chapter structure may change, and the
 * numbering the PDF prints comes from the backend chapter plan at render time.
 */
export interface BauwerksbuchBookInfoFormData {
  inspectionHistory: string;
  components: string;
  inspectorRequirements: string;
}

export class BauwerksbuchBookInfoForm extends Form<
  BauwerksbuchBookInfoFormData
> {
  protected definition = {
    inspectionHistory: {
      label: "Erstmalige und bisherige Überprüfung",
      type: FormFieldType.Text,
      required: false
    },
    components: {
      label:
        "Bauteile, die einer regelmäßigen Überprüfung unterzogen werden müssen",
      type: FormFieldType.Text,
      required: false
    },
    inspectorRequirements: {
      label: "Voraussetzungen für die überprüfende Person",
      type: FormFieldType.Text,
      required: false
    }
  };
}
